export default __webpack_public_path__ + "static/media/download-icon-light.eff4e0bd.svg";